import { useStateSelector } from '../../../data/global/dataSelectors';

export const useEntitlementsData = (blockId: string) => {
  const data = useStateSelector(s => (s.private.entitlements.entitlementDataByBlockId && s.private.entitlements.entitlementDataByBlockId[blockId] && s.private.entitlements.entitlementDataByBlockId[blockId].entitlements) || []);
  const total = useStateSelector(s => (s.private.entitlements.entitlementDataByBlockId && s.private.entitlements.entitlementDataByBlockId[blockId] && s.private.entitlements.entitlementDataByBlockId[blockId].total) || 0);
  const page = useStateSelector(s => (s.private.entitlements.entitlementDataByBlockId && s.private.entitlements.entitlementDataByBlockId[blockId]) ? s.private.entitlements.entitlementDataByBlockId[blockId].page || 0 : 0);
  const pageSize = useStateSelector(s => (s.private.entitlements.entitlementDataByBlockId && s.private.entitlements.entitlementDataByBlockId[blockId]) ? s.private.entitlements.entitlementDataByBlockId[blockId].pageSize || 10 : 10);

  return {
    data,
    total,
    page,
    pageSize,
  };
};
